import {FinancementRessource} from '../api/FinancementRessource';

export class ExFinancementRessource extends FinancementRessource {
    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }
    }
}
